import { render, staticRenderFns } from "./StockListPackagings.vue?vue&type=template&id=53ebd2cb"
import script from "./StockListPackagings.vue?vue&type=script&lang=js"
export * from "./StockListPackagings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports